import { createBrowserRouter, Outlet } from "react-router-dom";
import TakeOffRoute from "./components/takeoff-route.tsx";
import WebsiteLayout from "../layouts/website";
import NotFoundPage from "../pages/not-found";
import HomePage from "../pages/home/index.tsx";
import signInAction from "../pages/sign-in/sign-in-action.ts";
import SignInPage from "../pages/sign-in";
import ProjectsContextProvider from "../services/context/projects/projects-context-provider.tsx";
import ProtectedRoutes from "../classes/protected-route.tsx";
import ProjectsPage from "../pages/projects";
import MultiProjectsPage from "../pages/multi-projects";
import TakeOffLanding from "../pages/takeoff-landing";

const pagesRouter = createBrowserRouter([
    {
        path: "/",
        element: (
            <>
                <Outlet />
            </>
        ),
        errorElement: (
            <WebsiteLayout>
                <NotFoundPage />
            </WebsiteLayout>
        ),
        children: [
            {
                path: "",
                element: <HomePage />,
            },
            {
                path: "sign-in",
                action: signInAction,
                element: <SignInPage />,
            },
        ]
    },
    {
        element:
            <ProjectsContextProvider>
                <ProtectedRoutes />
            </ProjectsContextProvider>,
        errorElement: (
            <WebsiteLayout>
                <NotFoundPage />
            </WebsiteLayout>
        ),
        children: [
            {
                path: "projects",
                element: (
                    <WebsiteLayout>
                        <ProjectsPage />
                    </WebsiteLayout>
                ),
            },
            {
                path: "takeoff",
                element: (
                    <WebsiteLayout>
                        <TakeOffLanding />
                    </WebsiteLayout>
                )
            },
            {
                path: "takeoff/:id",
                element: (
                    <TakeOffRoute />
                )
            },
            {
                path: "multi-projects",
                element: (
                    <WebsiteLayout>
                        <MultiProjectsPage />
                    </WebsiteLayout>
                ),
            },
        ],
    },
]);

export default pagesRouter;